module.exports = __webpack_public_path__ + "assets/img/27_1457_big.7788b1e0.jpg";